// @flow
import {
  REQUEST_CALENDAR,
  REQUEST_CALENDAR_SUCCESS,
  REQUEST_CALENDAR_FAILED
} from "../actions/calendar";
import type { Calendar } from "../models/calendar";
import type { ActionWithData, StateWithData } from "../helpers/types";

export type CalendarData = {
  [calendar: number]: Calendar
};
export type CalendarState = StateWithData<CalendarData>;
export type CalendarAction = ActionWithData<CalendarData>;

export function calendar(
  state: CalendarState = { data: {} },
  action: CalendarAction
): CalendarState {
  switch (action.type) {
    case REQUEST_CALENDAR:
      return state;
    case REQUEST_CALENDAR_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          ...action.data
        },
        error: null
      };
    case REQUEST_CALENDAR_FAILED:
      return {
        ...state,
        error: action.error
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/calendar.js